module.exports = __webpack_public_path__ + "static/thumbnail-s-a7ec8fc91a500d41ab886eaad3750343.png";